$(function () {
	$('.col-height').matchHeight({
		byRow: true,
		property: 'height',
		target: null,
		remove: false
	});
});



// WEBPACK FOOTER //
// ./_dev/blocks/col-height/col-height.js